import { useEffect, useRef, useState } from "react";
import { DropFiles, DropZoneArea, DropZoneAreaItem, FormControl, Helper, InputAttachmentWrapper, Label, SearchFile, SearchFileText } from "./Style";
import { defaultTypes } from "./StyleType";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import DeleteButtonIMG from '../../../assets/deleteFile.png';
import { FieldAttachment } from "../../../forms/FormFieldAttachmentBase";

import { Grid, CircularProgress, Box } from '@material-ui/core';
import { useDropzone } from "react-dropzone";
import React from "react";
import { Alert } from "@material-ui/lab";
import TmpModalCustom from "../TmpModalCustom/TmpModalCustom";
import TmpLinkCustom from "../TmpLinkCustom/TmpLinkCustom";

interface TmpAttachmentCustomProps {
    label: string;
    id: string;
    name: string;
    mandatory?: boolean;
    disabled?: boolean;
    values: FieldAttachment[];
    limitedFiles: number;
    linkFile?: string;
    linkFileName?: string;
    typeFiles: string;
    helperIcon?: "info" | "error" | "warning";
    helperText?: string;
    error?: boolean;
    onChange: (e: FieldAttachment) => void;
    onDeleteFile: (e: FieldAttachment) => void;
}


export default function TmpAttachmentCustom(props: TmpAttachmentCustomProps) {

    const [files, setFiles] = useState<FieldAttachment[]>([]);
    const [deleteValue, setDeleteValue] = useState<FieldAttachment>();
    const [_isOpenedModalConfirm, setIsOpenedModalConfirm] = useState(false);

    const onDrop = React.useCallback(acceptedFiles => {
        if (acceptedFiles) {
            acceptedFiles.forEach((file: any) => {
                const reader = new FileReader()
                reader.readAsArrayBuffer(file)
                props.onChange(new FieldAttachment(file, ""))
            })
        } else {
            setFiles(() => [...props.values])
        }
    }, [props]);

    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: props.limitedFiles,
        multiple: false,
        accept: props.typeFiles,
        noKeyboard: true,
        onDrop
    });


    useEffect(() => {
        if (props.values != null && props.values.length > 0) {
            setFiles(() => [...props.values])
        } else {
            setFiles([])
        }
    }, [props.values]);

    const allFiles = files.map((file, i) => (
        <DropZoneAreaItem key={i}>
            {file.File.path}
            {((file.Id === "" || file.IsLoading) && file.ErrorMessage === "") ?
                <Box style={{ width: '2em', float: 'right' }}>
                    <CircularProgress style={{ 'color': 'gray', marginRight: 5, marginTop: 5 }} size={20} />
                </Box>
                :
                <img style={{ cursor: "pointer", width: '2em', float: 'right' }} alt="Ýcone  para deletar uma imagem" src={DeleteButtonIMG} onClick={() => handleOpenModalChild(file, i)} />
            }

            {file.ErrorMessage ?
                <Alert severity="error">{file.ErrorMessage}</Alert>
                : null
            }

        </DropZoneAreaItem>
    ));


    const handleOpenModalChild = (file: FieldAttachment, index: number) => {
        setIsOpenedModalConfirm(true);
        setDeleteValue(file);
    };

    const onConfirmClick = () => {
        if (deleteValue) {
            setIsOpenedModalConfirm(false);
            props.onDeleteFile(deleteValue);
        }
    }

    const [_keyboardFocus, setKeyboardFocus] = useState(false);
    const [_inputFocus] = useState(false);
    const refInput = useRef<HTMLInputElement>(null);
    const labelId = `${props.id}-label`;

    // Events
    const _handleKeyBoardEvents = (e: any) => {
        if (e.code === "Tab") {
            setKeyboardFocus(true);
            handleSetInputFocus();
        } else {
            setKeyboardFocus(false);
        }
    };

    const handleSetInputFocus = () => {
        if (refInput !== null && refInput.current !== null) {
            refInput.current.focus();
        }
    }

    // Passing style props to styled component
    FormControl.defaultProps = defaultTypes;
    Label.defaultProps = defaultTypes;
    InputAttachmentWrapper.defaultProps = defaultTypes;
    DropFiles.defaultProps = defaultTypes;
    SearchFile.defaultProps = defaultTypes;
    Helper.defaultProps = defaultTypes;

    return (
        <FormControl
            tabFocus={_keyboardFocus}
            focus={_inputFocus}
            onKeyUp={_handleKeyBoardEvents}
            onClick={handleSetInputFocus}
            error={props.error ? true : false}
            disabled={props.disabled ? true : false}>

            <div className="tabFocus">
                <Label htmlFor={props.id} id={labelId}>{props.label}{props.mandatory ? " * " : " "}
                    {props.linkFileName && props.linkFile ? 
                    <TmpLinkCustom href={props.linkFile} download={true}>
                        {props.linkFileName}
                    </TmpLinkCustom>
                    :null
                    }
                </Label>

                <Grid container >
                    <Grid item xs={12}>
                        <InputAttachmentWrapper className="input-wrapper">
                            <DropFiles>
                                {allFiles}
                            </DropFiles>
                            {files.length < props.limitedFiles &&

                                <DropZoneArea {...getRootProps({})}>

                                    <SearchFile>
                                        <label>Procurar</label>
                                    </SearchFile>
                                    <SearchFileText> ou arraste e solte um documento aqui</SearchFileText>

                                    <input type="file" name={props.name}  {...getInputProps()} />
                                </DropZoneArea>
                            }
                        </InputAttachmentWrapper>
                    </Grid>
                </Grid>
            </div>

            <Helper disabled={props.disabled ? true : false}>
                {props.helperIcon === "error" && props.error &&
                    <span className="icon error">
                        <TmpIconCustom size="sm" icon={<IconError />} />
                    </span>
                }
                {props.helperIcon === "info" &&
                    <span className="icon">
                        <TmpIconCustom size="sm" icon={<IconInfo />} />
                    </span>
                }
                {props.helperIcon === "warning" &&
                    <>
                    <span className="icon error">
                        <TmpIconCustom size="sm" icon={<IconInfo />} />
                    </span>
                    <span className="icon error">
                        {props.helperText}
                    </span>
                    </>
                }
                {props.helperIcon !== "warning" &&
                    <> 
                        {props.helperText}
                    </>
                }
            </Helper>


            <TmpModalCustom isDoubleAction={true} isOpened={_isOpenedModalConfirm} size="sm" handleConfirm={onConfirmClick} handleCancel={() => setIsOpenedModalConfirm(false)} labelPrimary="Confirmar" labelSecondary="Cancelar"  >
                <h3>Confirmar a exclusão</h3>
                <h4>Você confirma a exclusão do item selecionado ?</h4>
            </TmpModalCustom>

        </FormControl >
    );
}

